import { render } from "./ReturnRequestPanel.vue?vue&type=template&id=5099035a&ts=true"
import script from "./ReturnRequestPanel.vue?vue&type=script&lang=ts"
export * from "./ReturnRequestPanel.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__